import { DealCardFragments } from 'features/deals/cards/DealCard.fragments';
import { ListingCardFragments } from 'features/deals/cards/ListingCard';

import { gql } from '@apollo/client';

import { SellerDealsWithCarves } from './__generated__/SellerDealsWithCarves';

// Shared by every consumer of this query's `user.company.deals` selection -- centralized here,
// next to the query that produces it, instead of each consumer re-deriving an identical alias.
export type SellerDealsWithCarves_user_company_deals = NonNullable<
  NonNullable<NonNullable<SellerDealsWithCarves>['user']>['company']
>['deals'][number];
export type SellerDealsWithCarves_user_company_deals_bids = NonNullable<
  NonNullable<SellerDealsWithCarves_user_company_deals>['bids']
>[number];

export const FullBidFields = gql`
  fragment FullBidFields on DealBid {
    bid_id
    bidder
    bid_basis_points
    created_date
    prior_bid_id
    carve_name
    carve {
      field_name
      operator
      operand
      operandList
    }
    carve_summary {
      wa_coupon_bps
      wa_age_months
      wa_borrower_credit_score
      wa_current_balance_cents
      wa_dti_bps
      wa_ltv_bps
      wa_original_balance_cents
      wa_remaining_loan_terms_months
      loan_count
      current_balance_cents
      original_balance_cents
    }
    price {
      unpaid_balance
      rate_bps
      price
      transfer_amount
    }
    stipulations {
      bid_basis_points
      settlement_date_seconds
      is_servicing_retained
      servicing_rate_bps
      transfer_amount
      has_diligence_completion_date_seconds
      diligence_completion_date_seconds
      has_settlement_date_seconds
      has_percent_collateral_diligence
      percent_collateral_diligence_bps
      has_min_net_yield_to_buyer
      min_net_yield_to_buyer_bps
      custom_stipulations
    }
    terms {
      id
      name
      documentUrl
      documentSizeBytes
    }
    status
  }
`;

export const ListingFragmentData = gql`
  fragment ListingFragment on Listing {
    __typename
    id
    loan_count
    wa_borrower_credit_score
    wa_coupon_bps
    wa_loan_age_months
    wa_ltv_bps
    wa_remaining_loan_terms_months
    sale_id
    ...ListingCardListing
  }
  ${ListingCardFragments.listing}
`;

export const SELLER_DEALS_WITH_CARVES = gql`
  query SellerDealsWithCarves {
    user {
      id
      company {
        id
        deals(role: SELLER) {
          id
          ...DealCardDeal
          counterparty {
            ...DealCardCounterparty
          }
          listing {
            id
            ...ListingFragment
          }
          performance_summary {
            loan_count
            current_balance_cents
            original_balance_cents
            wa_age_months
            wa_remaining_loan_terms_months
            wa_coupon_bps
            wa_borrower_credit_score
            wa_ltv_bps
            wa_dti_bps
          }
          bids {
            ...FullBidFields
          }
        }
      }
    }
  }
  ${DealCardFragments.deal}
  ${DealCardFragments.counterparty}
  ${ListingFragmentData}
  ${FullBidFields}
`;
